import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { KalSelectionModel } from '@kalidea/kaligraphi';
import { switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { AllocationsListService } from 'src/app/_shared/services/allocations/list/allocations-list.service';
import { ActivitySalesState } from 'src/app/board/activity/stores/activity-sales/activity-sales.state';
import { AttributionBudgetModelDto } from 'src/graphql/generated-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-shared-allocation-list',
    templateUrl: './shared-allocation-list.component.html',
    styleUrls: ['./shared-allocation-list.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAllocationListComponent extends BaseComponent implements OnInit {

    currentActivityId$: Observable<number> = inject(Store).select(ActivitySalesState.currentActivityId);

    showArchiveControl = new FormControl(false);

    loading$ = this.allocationsListService.loading$;

    allocationsList$ = this.allocationsListService.displayedAllocationsList$;

    constructor(protected readonly cdr: ChangeDetectorRef,
                protected readonly allocationsListService: AllocationsListService) {
        super(cdr);
    }

    get title(): string {
        return this.allocationsListService.title;
    }

    get addButtonLabel(): string {
        return this.allocationsListService.addButtonLabel;
    }

    get displayArchiveToggleLabel(): string {
        return this.allocationsListService.displayArchiveToggleLabel;
    }

    get selection(): KalSelectionModel<AttributionBudgetModelDto> {
        return this.allocationsListService.selection;
    }

    navigateToCreation(): void {
        this.allocationsListService.navigateToCreation();
    }

    navigateToDetail(id: number): void {
        this.allocationsListService.navigateToDetail(id);
    }

    ngOnInit(): void {

        this.watch$ = this.currentActivityId$.pipe(
            switchMap(() => this.allocationsListService.initialize$()),
            switchMap(() => this.store.select(ActivitySalesState.currentActivityId)),
            switchMap(() => this.allocationsListService.getAllocationsList()),
            tap(() => this.cdr.markForCheck())
        );

        this.watch$ = this.showArchiveControl.valueChanges
            .pipe(
                tap(value => this.allocationsListService.displayArchiveChanged$.next(value))
            );
    }
}


